import { add, multiplyWithFactor } from "@pentacode/openapi";
import { dateSub, getRange } from "./utils";
export function calcVacationEntitlement(allContracts, { from, to }, { startLedgers }) {
    // TODO: there should be a contracts in range util fn
    const contracts = allContracts.filter((c) => c.start <= to && (!c.end || c.end > from));
    let total = 0;
    for (const contract of contracts) {
        let start = from >= contract.start ? from : contract.start; // this is a max function
        if (startLedgers && start < startLedgers) {
            start = startLedgers; // this is a max function
        }
        const end = !contract.end || contract.end > to ? to : contract.end;
        // [start, ...firstOfMonths, end]
        while (start < end) {
            const { from, to } = getRange(start, "month");
            const subEnd = to < end ? to : end; // This is a min fn
            const fraction = (dateSub(start, subEnd) / dateSub(from, to) / 12); // calculate the fraction of the month, then the fraction of months/year
            total = add(total, multiplyWithFactor(contract.vacationDays, fraction));
            start = subEnd;
        }
    }
    return total;
}
// TODO: this is only used in the UI, so once a shared UI package exists, move it there
export const formatAbsenceDayCount = (dayCount) => {
    const count = dayCount ?? 0;
    let formattedCount;
    if (count === 0.5) {
        formattedCount = "½";
    }
    else if (count % 1 === 0.5) {
        formattedCount = `${Math.floor(count)}½`;
    }
    else {
        formattedCount = String(count);
    }
    const plural = count !== 0 && count > 1 ? "Fehltage" : "Fehltag";
    return `${formattedCount} ${plural}`;
};
//# sourceMappingURL=vacation.js.map